var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"C-fragment C-fragment-html",class:("C-fragment-html--" + (_vm.content.type)),domProps:{"innerHTML":_vm._s(_vm.doFollowContent)}})}
var staticRenderFns = []

export { render, staticRenderFns }